
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField,
} from '@/components/RemoteDataTable.vue';

import VariantAddEdit from '@/views/DashView/VariantsList/VariantAddEdit.vue';
import { cloneDeep } from 'lodash';
import constants from '@/utils/constants';
function toHump(name) {
  return name.replace(/_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
}
class MenuVariantItem {
  id: string = '';
  variant_items = [];
  category_id: string = '';
  is_visable: number = 1;
  option: number = 1;
  max: string = '';
  min: string = '';
  outletCode: string = '';
  menuItemCode: string = '';
}

@Component({
  components: {
    editor: VariantAddEdit,
  },
})
export default class MenuVariantList extends RemoteDataTable<MenuVariantItem> {
  public pageTitle: string = 'Menu Variant List';

  public newButtonText: string = 'New Menu Variant';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'category_name', label: 'Category' }),
    new RemoteDataField({ key: 'is_visable', label: 'Visibility' }),
    new RemoteDataField({ key: 'outlet_code', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'menuItemCode', label: 'Menu Item Code' }),
  ];

  // to get page data
  get items(): MenuVariantItem[] {
    return this.$store.getters.GetAllVariantItem;
  }

  get paging(): MenuVariantItem[] {
    return this.$store.getters.PagingVariantItem;
  }

  get sorting(): MenuVariantItem[] {
    return this.$store.getters.SortingVariantItem;
  }

  get filtering(): MenuVariantItem[] {
    const { menuitemcode, outletcode } = this.$route.params;
    const FilteringVariantItem = cloneDeep(
      this.$store.getters.FilteringVariantItem
    );
    FilteringVariantItem.menuItemCode = menuitemcode;
    FilteringVariantItem.outlet_code = outletcode;
    FilteringVariantItem.category_id = FilteringVariantItem.category_id
      ? Number(FilteringVariantItem.category_id)
      : '';
    this.$store.commit('SET_FILTERING_VARIANTITEM', FilteringVariantItem);
    return FilteringVariantItem;
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingVariantItem', {
      byField: toHump(ctx.sortBy),
      isDesc: ctx.sortDesc,
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringVariantItem', {
      isResetFilter: isResetFilter,
    });
  }

  reload(id = null) {
    this.$store.dispatch('GetAllVariantItem');
  }
  mounted() {
    this.reload();
  }
  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteVariantItem', item.id)
          .then((response) => {
            this.$swal(
              constants.SUCCESS_MESSAGE,
              'Item Deleted',
              constants.STATUS_SUCCESS
            );
          })
          .catch((error) => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.menuvariant.pagingVariantItem.size = page;
    this.$store.dispatch('GetAllVariantItem');
  }
}
